/* ============================================================
   complete-the-look.js
   Valemont — hotfix estável: sem loop de MutationObserver
   ============================================================ */

(function () {
  'use strict';

  const VALEMONT_COLORS = {
    "Μαύρος": "#1a1a1a", "Black": "#1a1a1a",
    "Λευκό": "#f7f7f4", "White": "#f7f7f4",
    "Γκρί": "#8f918d", "Gray": "#8f918d",
    "Γκρι": "#8f918d", "Grey": "#8f918d",
    "Ανοιχτό γκρι": "#c2c3bf", "Light Gray": "#c2c3bf",
    "Μεσονύχτιο Γκρι": "#3a3d3c", "Midnight Gray": "#3a3d3c",
    "Μπεζ": "#cdb494", "Beige": "#cdb494",
    "Ανοιχτό Μπεζ": "#e0d3bb", "Light Beige": "#e0d3bb",
    "Άμμος": "#cdbb9e", "Sand": "#cdbb9e",
    "Κρέμα": "#eee7d4", "Cream": "#eee7d4",
    "Καστανός": "#6f4a32", "Brown": "#6f4a32",
    "Σοκολάτα": "#4f3329", "Chocolate": "#4f3329",
    "Κονιάκ": "#a9663a", "Cognac": "#a9663a",
    "Τερακότα": "#b55a3c", "Terracotta": "#b55a3c",
    "Πορτοκάλι": "#c46721", "Orange": "#c46721",
    "Κίτρινος": "#d1ad42", "Yellow": "#d1ad42",
    "Πράσινος": "#5f7f4d", "Green": "#5f7f4d",
    "Σοφιστικέ Πράσινο": "#97a585", "Sage Green": "#97a585",
    "Ελιά": "#65713e", "Olive": "#65713e",
    "Μπλε": "#416a91", "Blue": "#416a91",
    "Μπλε ναυτικό": "#1d2a44", "Navy Blue": "#1d2a44",
    "Μπλε μαρέν": "#1f3350", "Navy blue": "#1f3350",
    "Μπλε της Νύχτας": "#1c2436", "Midnight Blue": "#1c2436",
    "Μπλε Πετρόλ": "#2c5560", "Petrol Blue": "#2c5560",
    "Γαλάζιο": "#a7c5db", "Powder Blue": "#a7c5db",
    "Γαλάζιο του πάγου": "#cfe0e6",
    "Μωβ": "#6f5a86", "Purple": "#6f5a86"
  };


  const instances = new WeakMap();

  function forceStyle(node, rules) {
    if (!node) return;
    Object.entries(rules).forEach(([property, value]) => {
      node.style.setProperty(property, value, 'important');
    });
  }

  function applySafetyStyles(root) {
    if (!root) return;

    root.querySelectorAll('.ctl-item, .ctl__item').forEach((item) => {
      const controls = item.querySelector('.ctl-controls, .ctl__controls');
      const addButtons = Array.from(item.querySelectorAll('.ctl-add, .ctl__item-button'));
      const addInsideControls = controls
        ? Array.from(controls.querySelectorAll('.ctl-add, .ctl__item-button')).pop()
        : null;
      const add = addInsideControls || addButtons[0] || null;

      // Invariant: ADD is always the final direct child of the controls row.
      // Prefer the button already inside the row, remove legacy duplicates,
      // then append it again so its DOM position is guaranteed to be last.
      if (controls && add) {
        addButtons.forEach((duplicate) => {
          if (duplicate !== add) duplicate.remove();
        });
        controls.appendChild(add);
      }

      // Remove legacy visible field labels/text left by older versions or theme wrappers.
      item.querySelectorAll('.ctl__control-label, .ctl-label, .ctl__label, label').forEach((label) => {
        const text = (label.textContent || '').trim().toLowerCase();
        if (text === 'colour' || text === 'color' || text === 'size') label.remove();
      });
      if (controls) {
        Array.from(controls.childNodes).forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && /^(colour|color|size)$/i.test((node.textContent || '').trim())) node.remove();
        });
      }

      forceStyle(item, {
        display: 'flex', 'flex-wrap': 'nowrap', 'align-items': 'flex-start',
        gap: '12px', padding: '16px 0', 'border-bottom': '1px solid #e7e1d6',
        background: 'transparent'
      });

      const thumb = item.querySelector('.ctl-thumb, .ctl__thumb');
      forceStyle(thumb, {
        flex: '0 0 80px', width: '80px', height: '100px', display: 'block',
        overflow: 'hidden', background: '#f1ede4', 'text-decoration': 'none'
      });

      const thumbImage = item.querySelector('.ctl-thumb-img, .ctl__thumb-img');
      forceStyle(thumbImage, {
        display: 'block', width: '80px', height: '100px', 'max-width': 'none',
        'object-fit': 'cover', 'object-position': 'center', background: '#f1ede4'
      });

      const info = item.querySelector('.ctl-info, .ctl__item-body');
      forceStyle(info, { flex: '1 1 auto', 'min-width': '0' });

      const name = item.querySelector('.ctl-name, .ctl__item-title');
      forceStyle(name, {
        display: 'block', margin: '0', color: '#26221b',
        'font-family': 'var(--font-heading-family), Georgia, \"Times New Roman\", serif',
        'font-size': '17px', 'font-weight': '500', 'line-height': '1.25',
        'letter-spacing': '.01em', 'text-decoration': 'none', 'text-transform': 'none'
      });

      const price = item.querySelector('.ctl-price, .ctl__item-price-row');
      forceStyle(price, {
        display: 'flex', 'flex-wrap': 'wrap', 'align-items': 'baseline', gap: '8px',
        'margin-top': '4px', 'font-family': 'var(--font-body-family), Arial, sans-serif',
        'font-size': '15px', 'font-weight': '400', 'line-height': '1.4'
      });

      const oldPrice = item.querySelector('.ctl-price-old, .ctl__item-compare-price');
      const currentPrice = item.querySelector('.ctl-price-now, .ctl__item-price');
      forceStyle(oldPrice, {
        color: '#a59d8f', 'font-family': 'var(--font-body-family), Arial, sans-serif',
        'font-size': '15px', 'font-weight': '400', 'text-decoration': 'line-through'
      });
      forceStyle(currentPrice, {
        color: '#26221b', 'font-family': 'var(--font-body-family), Arial, sans-serif',
        'font-size': '15px', 'font-weight': '500'
      });

      forceStyle(controls, {
        display: 'flex', 'flex-direction': 'row', 'flex-wrap': 'wrap',
        'align-items': 'center', 'align-content': 'center', gap: '10px',
        width: '100%', 'max-width': '100%', 'min-width': '0',
        'margin-top': '10px', overflow: 'visible'
      });

      const colorRoot = item.querySelector('.ctl__color-root');
      forceStyle(colorRoot, { position: 'relative', display: 'flex', 'align-items': 'center', gap: '6px', flex: '0 0 auto', order: '1', 'max-width': '100%', 'min-width': '0', overflow: 'visible' });

      item.querySelectorAll('.ctl__swatch').forEach((swatch) => {
        const swatchColor = String(swatch.dataset.swatchColor || '#d8d2c6').trim();
        const selected = swatch.classList.contains('is-active') ||
          swatch.classList.contains('is-selected') ||
          swatch.getAttribute('aria-pressed') === 'true';

        swatch.replaceChildren();

        forceStyle(swatch, {
          flex: '0 0 20px', width: '20px', height: '20px', 'min-width': '20px',
          padding: '0', border: '1px solid #d8d2c6', 'border-radius': '50%',
          'background-image': 'none', 'background-color': swatchColor, overflow: 'visible',
          display: 'inline-block', cursor: swatch.disabled ? 'not-allowed' : 'pointer'
        });
        swatch.style.setProperty(
          'box-shadow',
          selected ? '0 0 0 2px #fdfcf9, 0 0 0 3px #26221b' : 'none',
          'important'
        );
      });

      const size = item.querySelector('.ctl-size, .ctl__control--size');
      forceStyle(size, { position: 'relative', flex: '0 0 auto', width: 'auto', 'white-space': 'nowrap' });

      const choice = item.querySelector('.ctl__choice--size');
      forceStyle(choice, { position: 'relative', width: 'auto' });

      const trigger = item.querySelector('.ctl__choice--size .ctl__choice-trigger');
      const chosen = Boolean(choice && choice.classList.contains('has-value'));
      const errored = item.classList.contains('has-size-error');
      forceStyle(trigger, {
        appearance: 'none', '-webkit-appearance': 'none', border: '0',
        'border-bottom': `1px solid ${errored ? '#3f6847' : chosen ? '#26221b' : '#d8d2c6'}`,
        'border-radius': '0', background: 'transparent', width: 'max-content',
        'min-width': '0', height: '32px', padding: '0 2px', display: 'inline-flex',
        'align-items': 'center', gap: '8px', color: chosen ? '#26221b' : '#8c857a',
        'font-size': '12px', 'font-weight': '500', 'line-height': '1',
        'letter-spacing': '.04em', 'text-transform': 'uppercase', 'white-space': 'nowrap',
        'box-shadow': 'none', cursor: 'pointer'
      });

      const menu = item.querySelector('.ctl__choice--size .ctl__choice-menu');
      if (menu) {
        forceStyle(menu, {
          position: 'absolute', left: '0', top: '36px', 'z-index': '120',
          width: 'max-content', 'min-width': '0', 'max-width': 'none',
          'max-height': 'none', overflow: 'visible', 'overflow-x': 'visible',
          'overflow-y': 'visible', 'grid-template-columns': 'repeat(4, 44px)',
          gap: '6px', padding: '8px', border: '1px solid #e7e1d6',
          'border-radius': '0', background: '#fdfcf9',
          'box-shadow': '0 12px 30px rgba(40,34,24,.13)'
        });
        menu.style.setProperty('display', menu.hidden ? 'none' : 'grid', 'important');
      }

      item.querySelectorAll('.ctl__choice-option').forEach((option) => {
        forceStyle(option, {
          appearance: 'none', width: '44px', 'min-width': '44px', 'max-width': '44px',
          height: '38px', 'min-height': '38px', display: 'grid', 'place-items': 'center',
          padding: '0', color: option.disabled ? '#c8c0b2' : '#26221b',
          'font-size': '12px', 'line-height': '1', 'letter-spacing': '.04em',
          'text-transform': 'uppercase', 'white-space': 'nowrap', 'text-align': 'center'
        });
        option.style.setProperty('text-decoration', option.disabled ? 'line-through' : 'none', 'important');
        option.style.setProperty('pointer-events', option.disabled ? 'none' : 'auto', 'important');
      });

      const errorText = item.querySelector('.ctl__choice-error');
      if (errorText) {
        forceStyle(errorText, {
          position: 'absolute', top: '34px', left: '0', color: '#1a1a1a',
          'font-size': '10px', 'white-space': 'nowrap'
        });
        errorText.style.setProperty('display', errorText.hidden ? 'none' : 'block', 'important');
      }

      const added = item.classList.contains('is-selected') || add?.classList.contains('is-added') || add?.getAttribute('aria-pressed') === 'true';
      const disabled = add?.classList.contains('is-disabled') || add?.getAttribute('aria-disabled') === 'true';
      forceStyle(add, {
        appearance: 'none', '-webkit-appearance': 'none', position: 'static',
        inset: 'auto', top: 'auto', right: 'auto', bottom: 'auto', left: 'auto',
        transform: 'none', order: '999', 'align-self': 'center',
        flex: '0 0 auto', 'margin-left': 'auto', 'margin-inline-start': 'auto',
        'margin-top': '0', 'margin-bottom': '0', 'min-width': '56px', height: '32px', padding: '0 16px',
        display: 'inline-flex', 'align-items': 'center', 'justify-content': 'center',
        border: `1px solid ${added ? '#3f6847' : disabled ? '#d8d2c6' : '#3f6847'}`,
        'border-radius': '0', background: added ? '#fff' : disabled ? 'transparent' : '#3f6847',
        color: added ? '#3f6847' : disabled ? '#8c857a' : '#fff',
        'font-size': '11px', 'font-weight': '600', 'line-height': '1',
        'letter-spacing': '.10em', 'text-transform': 'none', 'white-space': 'nowrap',
        'box-shadow': 'none', cursor: disabled ? 'default' : 'pointer'
      });

      const addText = add && add.querySelector('.ctl__item-button-add');
      const addedText = add && add.querySelector('.ctl__item-button-added');
      if (addText) {
        if (addText.textContent !== 'Add') addText.textContent = 'Add';
        addText.style.setProperty('display', added ? 'none' : 'inline', 'important');
      }
      if (addedText) addedText.style.setProperty('display', added ? 'inline' : 'none', 'important');
    });

    const list = root.querySelector('.ctl__list');
    forceStyle(list, { 'border-top': '1px solid #e7e1d6' });

    const footer = root.querySelector('.ctl-footer, .ctl__footer');
    forceStyle(footer, { 'border-top': '1px solid #e7e1d6', 'margin-top': '4px', 'padding-top': '16px' });

    const summary = root.querySelector('.ctl-summary, .ctl__selection-summary');
    forceStyle(summary, { 'font-family': 'var(--font-body-family), Arial, sans-serif', 'font-size': '11px', 'letter-spacing': '.04em', color: '#8c857a', 'margin-bottom': '8px' });
    if (summary) { summary.hidden = false; summary.style.setProperty('display', 'block', 'important'); }

    const cta = root.querySelector('.ctl-cta, .ctl__cta');
    if (cta) {
      const active = !cta.disabled && cta.getAttribute('aria-disabled') !== 'true';
      forceStyle(cta, {
        width: '100%', height: '52px', border: `1px solid ${active ? '#3f6847' : '#d8d2c6'}`,
        background: active ? '#3f6847' : 'transparent', color: active ? '#fff' : '#8c857a',
        'font-family': 'var(--font-body-family), Arial, sans-serif', 'font-size': '12px', 'font-weight': '600', 'text-transform': 'none',
        'letter-spacing': '.12em', cursor: active ? 'pointer' : 'default',
        display: 'flex', 'align-items': 'center', 'justify-content': 'center'
      });
    }
  }


  function formatMoney(cents) {
    const format = (window.Shopify && window.Shopify.money_format) || '€{{amount}}';
    const numeric = Number(cents || 0);
    const amount = (numeric / 100).toFixed(2).replace('.', ',');

    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', String(Math.round(numeric / 100)))
      .replace('{{amount_with_comma_separator}}', amount);
  }

  function uniqueValues(items, key) {
    const values = [];
    const seen = new Set();

    items.forEach((item) => {
      const value = String(item && item[key] ? item[key] : '').trim();
      if (!value || seen.has(value)) return;
      seen.add(value);
      values.push(value);
    });

    return values;
  }

  function normalizeUrl(url) {
    return String(url || '').split('?')[0];
  }


  // Solid swatch colour is resolved by the exact Shopify variant option name.
  // The native Shopify swatch colour is used only when the fixed table has no match.

  function paintSwatch(button, optionName, explicitColor) {
    const exactColorName = String(optionName || '').trim();
    const nativeSwatchColor = String(explicitColor || '').trim();
    const cssColor = VALEMONT_COLORS[exactColorName] || nativeSwatchColor || '#d8d2c6';

    button.replaceChildren();
    button.dataset.swatchMode = 'color';
    button.dataset.swatchColor = cssColor;

    button.style.removeProperty('--ctl-swatch-color');
    button.style.setProperty('background-image', 'none', 'important');
    button.style.setProperty('background-color', cssColor, 'important');
    button.style.setProperty('border-radius', '50%', 'important');
  }

  // Build one record per REAL Shopify colour in the exact order in which
  // that colour first appears in product.variants. A representative variant
  // ID is stored on the swatch, preferring the first available variant for
  // that exact colour. No parallel positional array is used.
  function buildColorRecords(variants) {
    const records = [];
    const byExactColor = new Map();

    (variants || []).forEach((variant) => {
      const color = String(variant && variant.color ? variant.color : '').trim();
      if (!color) return;

      let record = byExactColor.get(color);
      if (!record) {
        record = {
          color,
          variantId: variant.id,
          available: variant.available !== false,
          swatchColor: variant.swatchColor || ''
        };
        byExactColor.set(color, record);
        records.push(record);
        return;
      }

      if (!record.available && variant.available !== false) {
        record.available = true;
        record.variantId = variant.id;
        if (variant.swatchColor) record.swatchColor = variant.swatchColor;
      }

    });

    return records;
  }

  function choiceChevron() {
    return '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function positionChoiceMenu(choice, menu) {
    if (!choice || !menu) return;

    const viewportPadding = 12;

    menu.style.setProperty('left', '0', 'important');
    menu.style.setProperty('right', 'auto', 'important');
    menu.style.setProperty('transform', 'none', 'important');
    menu.style.setProperty('max-width', `calc(100vw - ${viewportPadding * 2}px)`, 'important');

    let rect = menu.getBoundingClientRect();

    if (rect.right > window.innerWidth - viewportPadding) {
      menu.style.setProperty('left', 'auto', 'important');
      menu.style.setProperty('right', '0', 'important');
      rect = menu.getBoundingClientRect();
    }

    if (rect.left < viewportPadding) {
      const shift = viewportPadding - rect.left;
      menu.style.setProperty('transform', `translateX(${shift}px)`, 'important');
    }
  }

  function closeAllChoices(except = null) {
    document.querySelectorAll('.ctl__choice.is-open').forEach((choice) => {
      if (choice === except) return;
      choice.classList.remove('is-open');
      const trigger = choice.querySelector('.ctl__choice-trigger');
      const menu = choice.querySelector('.ctl__choice-menu');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) {
        menu.hidden = true;
        // applySafetyStyles sets an inline !important display value. Keep the
        // closed state explicit so opening/closing never depends on CSS order.
        menu.style.setProperty('display', 'none', 'important');
      }
    });
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('.ctl__swatch-overflow-wrap')) return;
    document.querySelectorAll('.ctl__swatch-overflow:not([hidden])').forEach((menu) => {
      menu.hidden = true;
      const trigger = menu.parentElement && menu.parentElement.querySelector('.ctl__swatch-more');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });

  class CompleteLook {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.root = document.getElementById(`ctl-${sectionId}`);

      if (!this.root) return;
      if (instances.has(this.root)) return instances.get(this.root);

      instances.set(this.root, this);

      this.items = Array.from(this.root.querySelectorAll('.ctl__item'));
      this.cta = this.root.querySelector('.ctl__cta');
      this.selectionSummary = this.root.querySelector('.ctl__selection-summary');
      this.ctaLabelText = this.root.querySelector('.ctl__cta-label-text');
      this.ctaTotal = this.root.querySelector('.ctl__cta-total');
      this.error = this.root.querySelector('.ctl__error');
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.mobileGallery = null;

      this.settings = {        addText: 'Add',
        addedText: this.root.dataset.itemAddedText || 'Added',
        selectSizeText: 'Select',
        sizeErrorText: 'Select an option',
        selectedCountText: this.root.dataset.selectedCountText || 'selected'
      };

      this.init();
    }

    init() {
      this.bindDesktopGallery();
      this.items.forEach((item) => this.initItem(item));

      if (this.cta && !this.cta.dataset.ctlBound) {
        this.cta.dataset.ctlBound = 'true';
        this.cta.addEventListener('click', () => this.addSelectedToCart());
      }

      this.updateFooter();
      applySafetyStyles(this.root);
      buildMobileGallery(this.root);
    }



    bindDesktopGallery() {
      const media = this.root.querySelector('.ctl__media');
      const mainImage = media && media.querySelector('.ctl__image');
      const thumbs = media ? Array.from(media.querySelectorAll('.ctl__gallery-thumb')) : [];
      const previous = media && media.querySelector('.ctl__gallery-arrow--prev');
      const next = media && media.querySelector('.ctl__gallery-arrow--next');

      if (!media || !mainImage || !thumbs.length || media.dataset.ctlDesktopGalleryBound === 'true') return;
      media.dataset.ctlDesktopGalleryBound = 'true';

      let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

      const show = (index) => {
        const safeIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
        const thumb = thumbs[safeIndex];
        const source = thumb.dataset.fullImage;

        if (!source) return;

        activeIndex = safeIndex;
        thumbs.forEach((node, thumbIndex) => node.classList.toggle('is-active', thumbIndex === safeIndex));

        mainImage.style.opacity = '0';
        mainImage.onload = () => {
          mainImage.style.opacity = '1';
        };
        mainImage.src = source;
        mainImage.removeAttribute('srcset');
        if (mainImage.complete) mainImage.style.opacity = '1';
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          show(index);
        });
      });

      if (previous) {
        previous.addEventListener('click', (event) => {
          event.preventDefault();
          show(activeIndex - 1);
        });
      }

      if (next) {
        next.addEventListener('click', (event) => {
          event.preventDefault();
          show(activeIndex + 1);
        });
      }
    }

    initItem(item) {
      const json = item.querySelector('.ctl__variants-json');

      if (!json) {
        this.bindItemButton(item);
        this.updateItemButton(item);
        return;
      }

      let variants = [];

      try {
        variants = JSON.parse(json.textContent || '[]');
      } catch (error) {
        console.error('[Valemont CTL] Variant JSON parse failed:', error);
        return;
      }

      item._ctlVariants = variants.map((variant) => ({
        ...variant,
        available: variant.available !== false
      }));

      const hasColor = item.dataset.hasColor === 'true';
      const hasSize = item.dataset.hasSize === 'true';

      if (hasColor) {
        this.buildColorControl(item);
      } else if (hasSize) {
        this.renderSizeOptions(item, item._ctlVariants);
      } else {
        const variant = item._ctlVariants.find((entry) => entry.available) || item._ctlVariants[0];
        if (variant) this.setVariant(item, variant);
      }

      this.bindItemButton(item);
      this.updateItemButton(item);
    }

    buildColorControl(item) {
      const root = item.querySelector('.ctl__color-root');
      const control = item.querySelector('.ctl-swatches');
      const variants = item._ctlVariants || [];
      const colorRecords = buildColorRecords(variants);

      if (!root || !colorRecords.length) {
        if (control) control.hidden = true;
        return;
      }

      root.innerHTML = '';
      if (control) control.hidden = false;

      const maxInlineSwatches = 5;
      // Always keep the first five colours from the SAME real-variant list.
      // Do not substitute or reorder entries when adding the +N link.
      const visibleRecords = colorRecords.slice(0, maxInlineSwatches);
      const initiallySelected = visibleRecords.find((record) => record.available) || visibleRecords[0];

      visibleRecords.forEach((record) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ctl__swatch';
        button.dataset.color = record.color;
        button.dataset.variantId = String(record.variantId || '');
        paintSwatch(button, record.color, record.swatchColor);
        button.setAttribute('aria-label', record.color);
        button.setAttribute('aria-pressed', 'false');
        button.title = record.color;
        button.disabled = !record.available;
        button.addEventListener('click', () => this.selectColorFromSwatch(item, button));
        root.appendChild(button);
      });

      const hiddenRecords = colorRecords.slice(maxInlineSwatches);
      const hiddenColorCount = hiddenRecords.length;
      if (hiddenColorCount > 0) {
        const overflowWrap = document.createElement('div');
        overflowWrap.className = 'ctl__swatch-overflow-wrap';

        const more = document.createElement('button');
        more.type = 'button';
        more.className = 'ctl__swatch-more';
        more.textContent = `+${hiddenColorCount}`;
        more.setAttribute('aria-label', `Show ${hiddenColorCount} more colour options`);
        more.setAttribute('aria-expanded', 'false');
        more.title = `Show ${hiddenColorCount} more colour options`;

        const overflow = document.createElement('div');
        overflow.className = 'ctl__swatch-overflow';
        overflow.hidden = true;
        overflow.setAttribute('role', 'group');
        overflow.setAttribute('aria-label', 'More colour options');

        hiddenRecords.forEach((record) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ctl__swatch ctl__swatch--overflow';
          button.dataset.color = record.color;
          button.dataset.variantId = String(record.variantId || '');
          paintSwatch(button, record.color, record.swatchColor);
          button.setAttribute('aria-label', record.color);
          button.setAttribute('aria-pressed', 'false');
          button.title = record.color;
          button.disabled = !record.available;
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.selectColorFromSwatch(item, button);
            overflow.hidden = true;
            more.setAttribute('aria-expanded', 'false');
          });
          overflow.appendChild(button);
        });

        more.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          document.querySelectorAll('.ctl__swatch-overflow:not([hidden])').forEach((menu) => {
            if (menu === overflow) return;
            menu.hidden = true;
            const trigger = menu.parentElement && menu.parentElement.querySelector('.ctl__swatch-more');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          });

          const willOpen = overflow.hidden;
          overflow.hidden = !willOpen;
          more.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });

        overflowWrap.appendChild(more);
        overflowWrap.appendChild(overflow);
        root.appendChild(overflowWrap);
      }

      if (initiallySelected) this.selectColor(item, initiallySelected.color);
    }

    selectColorFromSwatch(item, swatch) {
      const variants = item._ctlVariants || [];
      const variantId = String(swatch && swatch.dataset.variantId ? swatch.dataset.variantId : '');
      const representativeVariant = variants.find((variant) => String(variant.id) === variantId);
      const exactColor = representativeVariant
        ? String(representativeVariant.color || '').trim()
        : String(swatch && swatch.dataset.color ? swatch.dataset.color : '').trim();

      if (!exactColor) return;
      this.selectColor(item, exactColor);
    }

    appendSingleColorToTitle(item, color) {
      const title = item.querySelector('.ctl__item-title');
      if (!title || !color) return;

      const baseTitle = item.dataset.baseTitle || title.textContent.trim();
      item.dataset.baseTitle = baseTitle;

      const normalizedTitle = baseTitle.toLowerCase();
      const normalizedColor = String(color).trim().toLowerCase();

      if (normalizedTitle.includes(normalizedColor)) {
        title.textContent = baseTitle;
        return;
      }

      title.textContent = `${baseTitle} — ${color}`;
    }

    selectColor(item, color) {
      const variants = item._ctlVariants || [];
      const colorVariants = variants.filter((variant) => variant.color === color);
      const hasSize = item.dataset.hasSize === 'true';

      item.dataset.selectedColor = color;
      item.classList.remove('is-selected');

      item.querySelectorAll('.ctl__swatch').forEach((swatch) => {
        const active = swatch.dataset.color === color;
        swatch.classList.toggle('is-active', active && !swatch.classList.contains('ctl__swatch--single'));
        swatch.setAttribute('aria-pressed', active ? 'true' : 'false');
      });


      this.swapItemImage(item, colorVariants);

      if (hasSize) {
        this.renderSizeOptions(item, colorVariants);
      } else {
        const variant = colorVariants.find((entry) => entry.available) || colorVariants[0];
        if (variant) this.setVariant(item, variant);
      }
    }

    renderSizeOptions(item, variants) {
      const root = item.querySelector('.ctl__size-root');
      if (!root) return;

      root.innerHTML = '';
      const grouped = new Map();

      variants.forEach((variant) => {
        const label = String(variant.size || variant.title || '').trim();
        if (!label) return;
        if (!grouped.has(label) || (!grouped.get(label).available && variant.available)) {
          grouped.set(label, variant);
        }
      });

      const entries = Array.from(grouped.entries()).map(([label, variant]) => ({ label, variant }));
      if (!entries.length) return;

      const choice = document.createElement('div');
      choice.className = 'ctl__choice ctl__choice--size';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'ctl__choice-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.innerHTML = `<span class="ctl__choice-label ctl__choice-placeholder">${this.settings.selectSizeText}</span>${choiceChevron()}`;

      const menu = document.createElement('div');
      menu.className = 'ctl__choice-menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;

      const error = document.createElement('span');
      error.className = 'ctl__choice-error';
      error.hidden = true;
      error.textContent = this.settings.sizeErrorText;

      entries.forEach((entry) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'ctl__choice-option';
        option.dataset.variantId = String(entry.variant.id);
        option.setAttribute('role', 'option');
        option.textContent = entry.label;
        option.disabled = !entry.variant.available;

        option.addEventListener('click', () => {
          if (!entry.variant.available) return;
          item.classList.remove('is-selected', 'has-size-error');
          error.hidden = true;
          trigger.querySelector('.ctl__choice-label').textContent = entry.label;
          trigger.querySelector('.ctl__choice-label').classList.remove('ctl__choice-placeholder');
          choice.classList.add('has-value');
          menu.querySelectorAll('.ctl__choice-option').forEach((node) => {
            const active = node.dataset.variantId === String(entry.variant.id);
            node.classList.toggle('is-active', active);
            node.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          closeAllChoices();
          this.setVariant(item, entry.variant);
        });

        menu.appendChild(option);
      });

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const opening = !choice.classList.contains('is-open');
        closeAllChoices(choice);
        choice.classList.toggle('is-open', opening);
        trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
        menu.hidden = !opening;

        // The safety layer writes display:none!important while the menu starts
        // hidden. Removing only the hidden attribute is therefore not enough.
        // Explicitly switch the inline display value whenever the trigger is used.
        menu.style.setProperty('display', opening ? 'grid' : 'none', 'important');
        if (opening) {
          requestAnimationFrame(() => positionChoiceMenu(choice, menu));
        }
      });

      choice.appendChild(trigger);
      choice.appendChild(menu);
      choice.appendChild(error);
      root.appendChild(choice);
      this.clearVariant(item);
    }

    clearVariant(item) {
      const input = item.querySelector('.ctl__variant-id');
      if (input) {
        input.value = '';
        input.dataset.price = '';
        input.dataset.comparePrice = '';
        input.dataset.title = '';
      }

      item.classList.remove('is-selected');
      this.updateItemButton(item);
      this.updateFooter();
    }

    setVariant(item, variant) {
      const input = item.querySelector('.ctl__variant-id');
      if (!input || !variant) return;

      input.value = variant.available ? String(variant.id) : '';
      input.dataset.price = variant.available ? String(variant.price || 0) : '';
      input.dataset.comparePrice = variant.available ? String(variant.compare_at_price || 0) : '';
      input.dataset.title = variant.title || '';

      const price = item.querySelector('.ctl__item-price');
      const comparePrice = item.querySelector('.ctl__item-compare-price');
      const compareAt = Number(variant.compare_at_price || 0);
      const current = Number(variant.price || 0);

      if (price) price.textContent = formatMoney(current);

      if (comparePrice) {
        comparePrice.textContent = compareAt > current ? formatMoney(compareAt) : '';
        comparePrice.classList.toggle('is-hidden', compareAt <= current);
      }


      this.updateItemButton(item);
      this.updateFooter();
    }

    swapItemImage(item, variants) {
      const image = item.querySelector('.ctl__thumb-img');
      const variant = (variants || []).find((entry) => entry.available && entry.image) ||
        (variants || []).find((entry) => entry.image);

      if (!image || !variant || !variant.image) return;

      image.style.opacity = '0';
      image.onload = () => {
        image.style.opacity = '1';
      };
      image.src = variant.image;
      if (image.complete) image.style.opacity = '1';
    }

    bindItemButton(item) {
      const button = item.querySelector('.ctl__item-button');
      if (!button || button.dataset.ctlBound === 'true') return;

      button.dataset.ctlBound = 'true';
      button.addEventListener('click', () => {
        const input = item.querySelector('.ctl__variant-id');

        if (!input || !input.value) {
          this.showSizeError(item);
          return;
        }

        const selected = item.classList.toggle('is-selected');
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        this.clearError();
        this.updateItemButton(item);
        this.updateFooter();
      });
    }

    showSizeError(item) {
      const choice = item.querySelector('.ctl__choice--size');
      const trigger = choice && choice.querySelector('.ctl__choice-trigger');
      const error = choice && choice.querySelector('.ctl__choice-error');

      if (!choice || !trigger) return;
      item.classList.add('has-size-error');
      if (error) error.hidden = false;
      trigger.focus({ preventScroll: true });

      window.clearTimeout(item._ctlSizeErrorTimer);
      item._ctlSizeErrorTimer = window.setTimeout(() => {
        item.classList.remove('has-size-error');
        if (error) error.hidden = true;
      }, 3000);
    }

    updateItemButton(item) {
      const button = item.querySelector('.ctl__item-button');
      const input = item.querySelector('.ctl__variant-id');
      if (!button) return;

      const hasVariant = Boolean(input && input.value);
      const selected = item.classList.contains('is-selected');

      button.disabled = false;
      button.setAttribute('aria-disabled', hasVariant ? 'false' : 'true');
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.classList.toggle('is-disabled', !hasVariant);
      button.classList.toggle('is-added', selected);
      applySafetyStyles(this.root);
    }

    updateFooter() {
      const selected = this.items.filter((item) => item.classList.contains('is-selected'));
      const hasSelected = selected.length > 0;
      const total = selected.reduce((sum, item) => {
        const input = item.querySelector('.ctl__variant-id');
        return sum + Number(input && input.dataset.price ? input.dataset.price : 0);
      }, 0);

      if (this.cta) {
        this.cta.disabled = !hasSelected;
        this.cta.setAttribute('aria-disabled', hasSelected ? 'false' : 'true');
      }

      if (this.selectionSummary) {
        this.selectionSummary.hidden = false;
        this.selectionSummary.textContent = `${selected.length} of ${this.items.length} ${this.settings.selectedCountText}`;
      }

      if (this.ctaTotal) {
        this.ctaTotal.hidden = !hasSelected;
        this.ctaTotal.textContent = hasSelected ? `• ${formatMoney(total)}` : '';
      }
      applySafetyStyles(this.root);
    }

    async addSelectedToCart() {
      const items = this.items
        .filter((item) => item.classList.contains('is-selected'))
        .map((item) => {
          const input = item.querySelector('.ctl__variant-id');
          return input && input.value ? { id: Number(input.value), quantity: 1 } : null;
        })
        .filter(Boolean);

      if (!items.length) return;

      this.setLoading(true);
      this.clearError();

      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

      const payload = { items };
      const cartDrawer = document.querySelector('cart-drawer');
      const cartTarget = cartDrawer || this.cart;

      if (cartTarget && typeof cartTarget.getSectionsToRender === 'function') {
        payload.sections = cartTarget.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Some items could not be added.');
        }

        // Use the theme's own cart-drawer renderer. In themes based on Dawn,
        // renderContents() updates the requested sections and opens the drawer
        // with its native overlay, focus trap and close controls. Do not click
        // the cart icon again after this, otherwise the drawer can be opened
        // twice and become stuck on mobile.
        if (cartTarget && typeof cartTarget.renderContents === 'function' && data.sections) {
          // renderContents already refreshes the cart drawer, cart icon and
          // opens the drawer with the theme's native state.
          //
          // Do not publish another cart refresh immediately afterwards.
          // That second refresh can rebuild/reopen the drawer while it is
          // closing, leaving only the dark overlay visible on mobile.
          cartTarget.renderContents(data);
          return;
        }

        // Generic fallback for themes without renderContents(): refresh the
        // public cart state, then let the existing header cart control open its
        // own drawer. We never rebuild drawer HTML or add open classes manually.
        await this.refreshCartState(root);
        window.setTimeout(() => this.openCartDrawer(), 80);
      } catch (error) {
        console.error('[Valemont CTL] Add to cart failed:', error);
        this.showError(error.message || 'Unexpected error. Please try again.');
      } finally {
        this.setLoading(false);
      }
    }

    async syncCartDrawer() {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('_ctl_cart_sync', String(Date.now()));

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) return;

        const html = await response.text();
        const documentCopy = new DOMParser().parseFromString(html, 'text/html');
        const selectors = [
          'cart-drawer',
          '#CartDrawer',
          '.cart-drawer',
          '#cart-icon-bubble',
          '.cart-count-bubble',
          '[data-cart-count]'
        ];

        selectors.forEach((selector) => {
          const current = document.querySelector(selector);
          const fresh = documentCopy.querySelector(selector);
          if (!current || !fresh) return;
          current.innerHTML = fresh.innerHTML;
        });
      } catch (error) {
        console.warn('[Valemont CTL] Cart drawer sync failed:', error);
      }
    }

    async refreshCartState(root) {
      try {
        const response = await fetch(`${root}cart.js`, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        const cart = await response.json();
        const detail = { source: 'complete-the-look', cart };

        ['cart:refresh', 'cart:updated', 'cart:change'].forEach((eventName) => {
          document.dispatchEvent(new CustomEvent(eventName, { detail }));
          window.dispatchEvent(new CustomEvent(eventName, { detail }));
        });

        if (typeof window.publish === 'function') {
          ['cart:refresh', 'cart:updated', 'cart:change'].forEach((eventName) => {
            try { window.publish(eventName, detail); } catch (error) {}
          });
        }
      } catch (error) {
        console.warn('[Valemont CTL] Cart refresh event failed:', error);
      }
    }

    openCartDrawer() {
      const triggerSelectors = [
        '#cart-icon-bubble',
        '.header__icon--cart',
        '[aria-controls="CartDrawer"]',
        '[aria-controls="cart-drawer"]',
        '[data-cart-toggle]',
        'cart-drawer-opener button',
        'cart-drawer-opener a'
      ];

      for (const selector of triggerSelectors) {
        const trigger = Array.from(document.querySelectorAll(selector)).find((node) => !node.closest('.ctl'));
        if (!trigger) continue;
        trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        return;
      }

      const drawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');
      if (!drawer) return;

      if (typeof drawer.open === 'function') drawer.open();
      else drawer.classList.add('active', 'is-open', 'open');
    }

    setLoading(loading) {
      if (!this.cta) return;
      const spinner = this.cta.querySelector('.ctl__spinner');
      const hasSelected = this.items.some((item) => item.classList.contains('is-selected'));

      this.cta.classList.toggle('is-loading', loading);
      this.cta.disabled = loading || !hasSelected;
      if (spinner) spinner.hidden = !loading;
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = false;
    }

    clearError() {
      if (!this.error) return;
      this.error.textContent = '';
      this.error.hidden = true;
    }
  }

  /* ============================================================
     MOBILE PRODUCT GALLERY + IN-PAGE ZOOM MODAL
     ============================================================ */

  function getGalleryImages(root) {
    const media = root.querySelector('.ctl__media');
    if (!media) return [];

    const images = [];
    const seen = new Set();
    const thumbs = Array.from(media.querySelectorAll('.ctl__gallery-thumb'));

    thumbs.forEach((thumb) => {
      const image = thumb.querySelector('img');
      const src = thumb.dataset.fullImage || (image && (image.currentSrc || image.src));
      const key = normalizeUrl(src);
      if (!src || seen.has(key)) return;
      seen.add(key);
      images.push({ src, alt: image ? image.alt || '' : '', thumb });
    });

    if (!images.length) {
      const main = media.querySelector('.ctl__image');
      const src = main && (main.currentSrc || main.src);
      if (src) images.push({ src, alt: main.alt || '', thumb: null });
    }

    return images;
  }

  function galleryIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="5.8" fill="none" stroke="currentColor" stroke-width="1.45"/><path d="m14.8 14.8 4.7 4.7M10.5 8v5M8 10.5h5" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/></svg>';
  }

  function closestSlideIndex(track, slides) {
    let index = 0;
    let distance = Infinity;

    slides.forEach((slide, slideIndex) => {
      const current = Math.abs(track.scrollLeft - slide.offsetLeft);
      if (current < distance) {
        distance = current;
        index = slideIndex;
      }
    });

    return index;
  }

  function scrollToSlide(track, slides, index, behavior = 'smooth') {
    if (!track || !slides.length) return;
    const safe = Math.max(0, Math.min(index, slides.length - 1));
    track.scrollTo({ left: slides[safe].offsetLeft, behavior });
  }

  function createZoomModal(root, images, getIndex) {
    const modal = document.createElement('dialog');
    modal.className = 'ctl-zoom-modal';
    modal.setAttribute('aria-label', 'Product image zoom');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    modal.innerHTML = `
      <div class="ctl-zoom-modal__dialog">
        <button type="button" class="ctl-zoom-modal__close" data-ctl-zoom-close aria-label="Close zoom">×</button>
        <div class="ctl-zoom-modal__counter" aria-live="polite"><span data-ctl-zoom-current>1</span>/<span>${images.length}</span></div>
        <button type="button" class="ctl-zoom-modal__nav ctl-zoom-modal__nav--prev" data-ctl-zoom-prev aria-label="Previous image">‹</button>
        <div class="ctl-zoom-modal__viewport">
          <img class="ctl-zoom-modal__image" alt="" draggable="false">
        </div>
        <button type="button" class="ctl-zoom-modal__nav ctl-zoom-modal__nav--next" data-ctl-zoom-next aria-label="Next image">›</button>
        <div class="ctl-zoom-modal__toolbar" aria-label="Zoom controls">
          <button type="button" data-ctl-zoom-out aria-label="Zoom out">−</button>
          <span data-ctl-zoom-level>100%</span>
          <button type="button" data-ctl-zoom-in aria-label="Zoom in">+</button>
        </div>
      </div>`;

    // A native <dialog> is rendered in the browser top layer. This avoids
    // transformed theme wrappers trapping position:fixed overlays.
    document.body.appendChild(modal);

    const image = modal.querySelector('.ctl-zoom-modal__image');
    const viewport = modal.querySelector('.ctl-zoom-modal__viewport');
    const currentNode = modal.querySelector('[data-ctl-zoom-current]');
    const levelNode = modal.querySelector('[data-ctl-zoom-level]');
    const previous = modal.querySelector('[data-ctl-zoom-prev]');
    const next = modal.querySelector('[data-ctl-zoom-next]');
    const zoomIn = modal.querySelector('[data-ctl-zoom-in]');
    const zoomOut = modal.querySelector('[data-ctl-zoom-out]');
    const closeButton = modal.querySelector('[data-ctl-zoom-close]');

    let index = 0;
    let scale = 1;
    let previousBodyOverflow = '';

    const applyScale = () => {
      const availableWidth = Math.max(240, viewport.clientWidth - 24);
      const availableHeight = Math.max(240, viewport.clientHeight - 24);
      const naturalWidth = image.naturalWidth || 800;
      const naturalHeight = image.naturalHeight || 1000;
      const fitScale = Math.min(availableWidth / naturalWidth, availableHeight / naturalHeight);
      const fittedWidth = Math.max(1, naturalWidth * fitScale);

      image.style.width = `${Math.round(fittedWidth * scale)}px`;
      image.style.height = 'auto';
      image.style.maxWidth = 'none';
      image.style.maxHeight = 'none';
      levelNode.textContent = `${Math.round(scale * 100)}%`;
      zoomOut.disabled = scale <= 1;
      zoomIn.disabled = scale >= 3;
    };

    const showImage = (newIndex) => {
      index = ((newIndex % images.length) + images.length) % images.length;
      scale = 1;
      image.src = images[index].src;
      image.alt = images[index].alt || '';
      currentNode.textContent = String(index + 1);
      previous.disabled = images.length <= 1;
      next.disabled = images.length <= 1;
      viewport.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      image.onload = applyScale;
      if (image.complete) requestAnimationFrame(applyScale);
    };

    const open = () => {
      index = Math.max(0, Number(getIndex()) || 0);
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      showImage(index);

      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }

      modal.classList.add('is-open');
      requestAnimationFrame(() => {
        applyScale();
        closeButton.focus({ preventScroll: true });
      });
    };

    const close = () => {
      modal.classList.remove('is-open');

      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }

      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      document.body.style.overflow = previousBodyOverflow;
    };

    closeButton.addEventListener('click', close);
    previous.addEventListener('click', () => showImage(index - 1));
    next.addEventListener('click', () => showImage(index + 1));
    zoomIn.addEventListener('click', () => {
      scale = Math.min(3, scale + 0.5);
      applyScale();
    });
    zoomOut.addEventListener('click', () => {
      scale = Math.max(1, scale - 0.5);
      applyScale();
    });

    image.addEventListener('dblclick', () => {
      scale = scale === 1 ? 2 : 1;
      applyScale();
    });

    modal.addEventListener('click', (event) => {
      // Clicking the dark area outside the dialog closes the zoom.
      if (event.target === modal) close();
    });

    modal.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(index - 1);
      if (event.key === 'ArrowRight') showImage(index + 1);
    });

    window.addEventListener('resize', () => {
      if (modal.open) applyScale();
    });

    root._ctlOpenZoom = open;
    return { open, close };
  }

  function buildMobileGallery(root) {
    if (!root || root.dataset.ctlV14GalleryReady === 'true') return;

    const media = root.querySelector('.ctl__media');
    const mainWrap = media && media.querySelector('.ctl__main-image-wrap');
    const images = getGalleryImages(root);

    if (!media || !mainWrap || !images.length) return;

    media.querySelectorAll('.ctl-v14-mobile-gallery').forEach((node) => node.remove());

    const gallery = document.createElement('div');
    gallery.className = 'ctl-v14-mobile-gallery';
    gallery.setAttribute('aria-label', 'Product image gallery');

    const zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'ctl-v14-mobile-gallery__zoom';
    zoom.setAttribute('aria-label', 'Open image zoom');
    zoom.innerHTML = galleryIcon();

    const track = document.createElement('div');
    track.className = 'ctl-v14-mobile-gallery__track';

    images.forEach((entry, index) => {
      const slide = document.createElement('div');
      slide.className = 'ctl-v14-mobile-gallery__slide';
      slide.dataset.index = String(index);

      const image = document.createElement('img');
      image.src = entry.src;
      image.alt = entry.alt || '';
      image.width = 800;
      image.height = 1000;
      image.loading = index === 0 ? 'eager' : 'lazy';
      image.decoding = index === 0 ? 'sync' : 'async';
      image.draggable = false;

      slide.appendChild(image);
      track.appendChild(slide);
    });

    const status = document.createElement('div');
    status.className = 'ctl-v14-mobile-gallery__status';
    status.innerHTML = `
      <button type="button" class="ctl-v14-mobile-gallery__button" data-ctl-gallery-prev aria-label="Previous image">‹</button>
      <span class="ctl-v14-mobile-gallery__count" aria-live="polite"><span data-ctl-gallery-current>1</span>/<span>${images.length}</span></span>
      <button type="button" class="ctl-v14-mobile-gallery__button" data-ctl-gallery-next aria-label="Next image">›</button>`;

    gallery.appendChild(zoom);
    gallery.appendChild(track);
    gallery.appendChild(status);
    mainWrap.insertAdjacentElement('beforebegin', gallery);

    const slides = Array.from(track.querySelectorAll('.ctl-v14-mobile-gallery__slide'));
    const currentNode = gallery.querySelector('[data-ctl-gallery-current]');
    const previous = gallery.querySelector('[data-ctl-gallery-prev]');
    const next = gallery.querySelector('[data-ctl-gallery-next]');
    let currentIndex = 0;

    const update = () => {
      currentIndex = closestSlideIndex(track, slides);
      currentNode.textContent = String(currentIndex + 1);
      previous.disabled = currentIndex <= 0;
      next.disabled = currentIndex >= slides.length - 1;

      images.forEach((entry, index) => {
        if (entry.thumb) entry.thumb.classList.toggle('is-active', index === currentIndex);
      });
    };

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    }, { passive: true });

    previous.addEventListener('click', () => scrollToSlide(track, slides, currentIndex - 1));
    next.addEventListener('click', () => scrollToSlide(track, slides, currentIndex + 1));

    const zoomModal = createZoomModal(root, images, () => currentIndex);
    zoom.addEventListener('click', (event) => {
      event.preventDefault();
      zoomModal.open();
    });

    root.dataset.ctlV14GalleryReady = 'true';
    root.classList.add('ctl-v14-gallery-active');
    track.scrollLeft = 0;
    update();

    window.addEventListener('resize', () => {
      requestAnimationFrame(() => {
        scrollToSlide(track, slides, currentIndex, 'auto');
        update();
      });
    });
  }

  function initSection(sectionId) {
    const root = document.getElementById(`ctl-${sectionId}`);
    if (!root) return null;
    if (instances.has(root)) return instances.get(root);
    return new CompleteLook(sectionId);
  }

  function initAll(scope = document) {
    const roots = [];

    if (scope.matches && scope.matches('.ctl[id^="ctl-"]')) roots.push(scope);
    roots.push(...Array.from(scope.querySelectorAll('.ctl[id^="ctl-"]')));

    roots.forEach((root) => {
      const sectionId = root.dataset.sectionId || root.id.replace(/^ctl-/, '');
      initSection(sectionId);
    });
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.ctl__choice')) closeAllChoices();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllChoices();
  });

  window.ValemontCompleteLook = { init: initSection };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    window.setTimeout(() => initAll(event.target), 50);
  });
})();
